export default {
  toasts: {
    load_error: 'Gebyrsatserne kunne ikke indlæses',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  rates: {
    title: 'Behandlingsmargin',
    description:
      'Procent i %, plus et valgfrit fast beløb og minimumsbeløb pr. betaling. „Enhver betalingsmetode“ gælder, når der ikke findes en metodespecifik sats.',
    default: {
      inherits:
        'Der er ikke angivet nogen Adyen-sats, så denne partners restauranter på FoodAmigos’ Adyen betaler FoodAmigos’ standardsats nedenfor. En sats, du angiver her, erstatter den, og en sats angivet på en enkelt restaurant har fortsat forrang.',
      overridden:
        'Denne partners egen Adyen-sats erstatter FoodAmigos’ standardsats nedenfor for dens restauranter på FoodAmigos’ Adyen. Fjern den for at falde tilbage til standardsatsen.',
      own_adyen:
        'Dette partner behandler betalinger på sin egen Adyen-konto. Dets restauranter betaler intet behandlingsgebyr, medmindre der er angivet en sats her eller for en enkelt restaurant.',
      master:
        'Det er FoodAmigos’ standardsatser. Alle partnere på FoodAmigos’ Adyen uden en egen Adyen-sats bruger dem.',
      rows_title: 'FoodAmigos’ standardsatser',
    },
  },
};
